import axios from 'axios';
import { getAuth } from "firebase/auth";

// Unified API Service for Tariff Admin features within Site DNA
// Uses the same base URL structure as the main app

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Base axios instance
const api = axios.create({
    baseURL: API_BASE_URL, // site-dna-api URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(async (config) => {
    const auth = getAuth();
    if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export const agentApi = {
    list: () => api.get('/api/agents/'),
    create: (agentData) => api.post('/api/agents/', agentData),
    get: (id) => api.get(`/api/agents/${id}`),
    update: (id, data) => api.put(`/api/agents/${id}`, data),

    // Factory operations
    generateConfig: (pdfUri, utilityName) =>
        api.post('/api/agents/generate-config', { pdf_uri: pdfUri, utility_name: utilityName }),

    // Upload
    upload: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/agents/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
};

export const tariffApi = {
    extract: (pdfUri, agentId) =>
        api.post('/api/extract', { pdf_uri: pdfUri, agent_id: agentId }),
    approve: (variantData) =>
        api.post('/api/approve', variantData),
};

export default api;
